import { render, staticRenderFns } from "./VerifyBvn.vue?vue&type=template&id=258cc51e"
import script from "./VerifyBvn.vue?vue&type=script&lang=js"
export * from "./VerifyBvn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports